import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/test.environment';

export interface ActivityItem {
  activityDate: Date;
  activityType: string;
  description: string;
  projectNumber: number;
  createdBy: string;
  entityId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ActivityService {
  constructor(private http: HttpClient) {}

  // getRecentActivities(): Observable<ActivityItem[]> {
  //   return this.http.get<ActivityItem[]>(`${environment.apiBaseUrl}/api/activity/recent`);
  // }

  getRecentActivitiesByType(): Observable<ActivityItem[]> {
    return this.http.get<ActivityItem[]>(`${environment.apiBaseUrl}/api/activity/recent`);
  }
}
